import { getCookie } from "../cookie-helper";
import { removeProductListeners } from "./event-listeners";
import { getCart } from "./update";


// Select all elements on the page
const cartModal = document.querySelector("#cart-modal");
const emptyCartMessage = cartModal?.querySelector("#cart-empty-message");
const cartItemList = cartModal?.querySelector("#cart-item-list");
const cartModalFooter = cartModal?.querySelector("#cart-footer");
const cartTotalPrice = cartModal?.querySelector("#cart-total-price");
const cartToggles = document.querySelectorAll(".cart-toggle");


/**
 * Render cart content to the front-end by requesting the data from the WordPress API.
 * @param {Array} cart Cart items as array of product IDs (post IDs from WordPress)
 */
export function renderCartContent(cart) {
    const cartItems = cart || getCart(); // Get cart items from param or read cookie

    renderCartItemCount(cartItems.length); // Render number of products to the toggle buttons

    if (!cartModal) return; // Fallback if cart modal is not on the page

    // Check if currently are products in the cart
    if (cartItems.length === 0) {

        // No products => show message, hide cart footer and clear item list
        emptyCartMessage.classList.remove("hidden");
        cartModalFooter.classList.add("hidden");
        cartItemList.innerHTML = "";
        return;

    } else {

        // Has products => hide message and show cart footer
        emptyCartMessage.classList.add("hidden");
        cartModalFooter.classList.remove("hidden");

        // Fetch product data from custom WordPress API route
        fetch('/wp-json/f5/v1/fetch-cart-products')
            .then(response => response.json())
            .then(data => {

                // Render cart items and set them to the cart modal body
                let cartBody = "";
                data.forEach(product => {
                    cartBody += `
                    <div class="cart-item" data-product-id="${product.id}">
                    <div class="cart-item__description">
                        <div class="cart-item__label">
                            ${product.coin_name}
                            <span class="cart-item__label__sub">(${product.coin_category})</span>
                        </div>
                        <div class="cart-item__price">${formatPrice(product.price)}</div>
                    </div>
                    <button type="button" class="cart-item__remove-btn" title="Produkt aus Warenkorb entfernen" data-product-id="${product.id}">
                        <span class="screen-reader-text">Produkt aus Warenkorb entfernen</span>
                        <figure class="icon-frame icon-frame--90 icon-frame--primary-shade">
                            <i class="icon-bold-trash icon-frame__icon"></i>
                        </figure>
                    </button>
                </div>
                `;
                });
                cartItemList.innerHTML = cartBody;

                // Add event listeners to new buttons
                removeProductListeners();

                // Calculate total price of the cart
                let totalPrice = 0;
                data.forEach(product => {
                    totalPrice = totalPrice + product.price;
                });

                // Format total price of the cart and set it to the front-end
                cartTotalPrice.innerHTML = formatPrice(totalPrice);

            })
            .catch(error => {
                // Handle any errors that occurred during the fetch
                console.error('Failed fetching product data for cart:', error);
                return [];
            });

    }
}


/**
 * Render cart item count to the cart toggle buttons
 * @param {Int} itemCount Number of items in the cart
 */
function renderCartItemCount(itemCount) {
    cartToggles?.forEach(toggle => {
        toggle.querySelector(".cart-item-count").innerHTML = itemCount > 0 ? `(${itemCount})` : "";
    });
}


/**
 * Helper function to format a float or integer to a price string in EUR.
 * @param {*} price Value
 * @returns Price string in EUR
 */
function formatPrice(price = 0) {
    return Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    }).format(price);
}